import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StSliderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const StSlide = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
